import {deserialize} from '../serializes/search';
import {executeCustomSearch} from '../services/filtersService';
import {getReconSide, updateSortIndication} from '../../../_shared/GWTBridge/invoke/netForm';
import {SearchAction} from 'priority-web-sdk/enums';
import {
    generatorOpenSearchField,
    generatorSearchFieldAction,
    generatorSearchNextPage
} from '../services/searchesService';
import {generatorOpenDateSearchField, saveSearch} from '../services/filtersService';
import {serializeDateOptions} from '../serializes/filters/date';
import {getLocalizedText, texts, placeholders} from '../../../constants/TextConst';
import moment from 'moment';
import {formsStore} from '../../Form/stores/FormsStore';
import {getLocale} from '../../../Localization';
import {createFilter} from '../../Filters/actions/filters';
import {getDefaultOperator, Operator} from '../consts/operators';
import {Form} from '../../Form/stores/Form';
import {Search} from '../stores/Search';
import {Filter} from '../stores/Filter';

export const mockSearchField = {
    SearchLine: {
        2: {
            string1: '5.1% פטרוכימים ב 17/23 מדד 1787.457 אגח ל.צמוד',
            string2: '7560048',
            retval: '7560048'
        },
        3: {string1: '4.94% אמות אגח א 10/19', string2: '1097385', retval: '1097385'},
        4: {string1: '5% ממשל שקלית 0313 3/13', string2: '1107788', retval: '1107788'},
        5: {string1: '5.5% ממשלתי שקלית 0217 28.2.2017', string2: '1101575', retval: '1101575'},
        6: {string1: '6.5% מ. שחר 2683 31.1.16', string2: '9268335', retval: '9268335'},
        7: {string1: '7.5% שחר 2682 31.3.14', string2: '9268236', retval: '9268236'},
        8: {string1: '4.75% אלוני חץ אגח ג 06/13 מדד 2.26', string2: '3900099', retval: '3900099'},
        9: {string1: '4.75% קב דלק כג 11.14 מדד 1828.334', string2: '1107465', retval: '1107465'},
        10: {string1: '4.9% טלדור ב 10/17 מדד 1783.257', string2: '4770145', retval: '4770145'},
        11: {string1: 'Kennametal Inc.', string2: '500085M', retval: '500085M'},
        12: {string1: 'CRM Inc.', string2: '10001', retval: '10001'},
        13: {string1: 'Business Software Solutions Ltd.', string2: '1012-456', retval: '1012-456'},
        14: {string1: 'Mihshuv Ltd.', string2: 'EL03', retval: 'EL03'},
        15: {string1: 'Even hf.', string2: '685', retval: '685'},
        16: {string1: 'Acme Co.', string2: 'P000001', retval: 'P000001'},
        17: {string1: '0', string2: 'ל', retval: 'ל'},
        18: {string1: 'S1662295-00', string2: 'S1662295-00', retval: 'S1662295-00'},
        19: {string1: '0000', string2: '500129M', retval: '500129M'}
    },
    alignright: '1',
    cursor: 'By Name',
    ignorecase: '1',
    ismulti: '0',
    lines: '20',
    next: '1',
    nexttitle: 'Next Page',
    prevtitle: 'Previous Page',
    stack_cursor: '5',
    stack_last: '0000',
    stack_start: '0',
    start: '0',
    starttitle: 'Search Only from Beginning of Item',
    width: '64'
};

export const mockDateRange = [
    {str1: 'אתמול', retval: 'אתמול', idate: '16365600', date: '12/02/19'},
    {str1: 'היום', retval: 'היום', idate: '16367040', date: '13/02/19'},
    {str1: 'מחר', retval: 'מחר', idate: '16368480', date: '14/02/19'}
];

export function openSearchField(field, searchQuery: string = '') {
    return generatorOpenSearchField(field, searchQuery).then((result: any) => {
        if (result.Form[0].Search) {
            return result.Form[0].Search[0];
        }
        return result.Form[0].Choose ? result.Form[0].Choose[0] : {};
    });
}

export function changeSearchField(
    field,
    action: SearchAction = SearchAction.TextChange,
    searchQuery: string = ''
) {
    if (searchQuery.length || action === SearchAction.TypeChange) {
        /* build id from the form "self" (Form Identifier when in Sublevel)
         * and column number
         */
        const id = (formsStore.currentForm.self << 16) | field;
        return generatorSearchFieldAction(id.toString(), action, searchQuery).then(
            (result: any) => {
                return result.Form[0].Search[0];
            }
        );
    }
    return Promise.resolve();
}

export function scrollSearchField(field, page: number = 0, searchQuery: string = '') {
    const id = (formsStore.currentForm.self << 16) | field;
    return generatorSearchNextPage(id.toString(), page, searchQuery).then((result: any) => {
        return result.Form[0].Search[0];
    });
}

export function deleteFilter(filter) {
    filter.search.deleteFilter(filter.column.name);
}

function addReconSideFilter(search: Search) {
    const reconSideCol = 'COND';
    if (search.filters && search.filters.get('COND')) {
        return;
    }
    const form = search.store.form;
    const cond = getReconSide(form.session);
    const column = form.getColumnByName(reconSideCol);
    if (column) {
        const reconFilter = createFilter(column.field, form);
        reconFilter.setOperator(Operator.Equals);
        reconFilter.setValue({min: cond});
        search.setFilter(reconFilter);
    }
}

function filtersContainSort(search: Search) {
    if (search.filters === null) {
        return null;
    }
    return !!Array.from(search.filters.values()).find(f => f.issort);
}

function addReconSortFilters(search: Search) {
    const sortField = 'SORT';
    if (!filtersContainSort(search)) {
        return;
    }
    addSort(search, sortField, true);
    search.filters.forEach(filter => {
        if (filter.column.name === sortField) {
            filter.sortIndex = 0;
        } else {
            filter.sortIndex = filter.sortIndex + 1;
        }
    });
}

function addSort(search: Search, colName: string, isdesc: boolean) {
    const form = search.store.form;
    const column = form.getColumnByName(colName);
    if (column) {
        const filter = createFilter(column.field, form);
        filter.issort = true;
        filter.isdesc = isdesc;
        search.setFilter(filter);
    }
}

export function addSortToFilter(
    session: string,
    name: string,
    field: number,
    issort: boolean,
    isdesc: boolean
) {
    const form: Form = formsStore.getFormFromSession(session, name);

    //create new search if needed
    !form.searches.formSelected && form?.searches?.addNewFormSearch();
    const search: Search = form.searches.formSelected;

    //create or update filter
    //use tableViewColumns, because filters exist only in table view
    const column = form?.tableViewColumns?.get(field.toString());
    if (column) {
        let filter: Filter = search?.filters?.get(column.name);

        if (filter) {
            filter.issort = issort;
            filter.isdesc = isdesc;
        } else {
            filter = new Filter(null, {
                column,
                field: column.field,
                operator: getDefaultOperator(column),
                sortIndex: search ? search.filters.size : 1,
                issort: issort,
                isdesc: isdesc
            });
            search.setFilter(filter);
        }
    }
}

export async function refreshReconWithFilters(sessions: string[], name: string) {
    for (const session of sessions) {
        const form: Form = formsStore.getFormFromSession(session, name);
        const search = form.searches.formSelected;
        search && addReconSortFilters(search);
        await executeAdvancedSearch(
            search || new Search(form.searches),
            false,
            session !== sessions[0]
        );
    }
}

export function executeAdvancedSearch(search: Search, addToList?: boolean, ignoreGoFiled = false) {
    const form: Form = search.store.form;
    if (form.isRecon) {
        addReconSideFilter(search);
    }
    const outputJson = deserialize(search);
    const ignoreCase = !!search.ignoreCase;
    localStorage.setItem('IgnoreCase', JSON.stringify(ignoreCase));
    return executeCustomSearch(form, outputJson, ignoreCase, search.name, addToList, ignoreGoFiled)
        .then(() => {
            form.columns.forEach(column => {
                const filter = search.filtersArray.find(filter => column.field === filter.field);
                const isSort = !!filter?.issort;
                const isDesc = !!filter?.isdesc;
                updateSortIndication(
                    Number(search.store.form.table),
                    Number(column.field),
                    isSort,
                    isDesc
                );
            });
            search.filtersCounter
                ? search.store.setFormSelected(search)
                : search.store.setFormSelected(undefined);
        })
        .catch(err => console.log(err));
}

export function openDateSearchField(format) {
    const optionsCash = localStorage.getItem('DateOptions' + getLocale());
    const dateRange = optionsCash && JSON.parse(optionsCash);
    if (!dateRange || dateRange[1].date !== moment().format(format.slice(0, 8))) {
        return generatorOpenDateSearchField()
            .then(res => {
                const dateOptions = serializeDateOptions(res);
                localStorage.setItem('DateOptions' + getLocale(), JSON.stringify(dateOptions));
                return dateOptions;
            })
            .catch(err => console.log(err));
    } else {
        return Promise.resolve(dateRange);
    }
}

export function saveCustomSearch(search) {
    if (formsStore.currentForm.isRecon) {
        addReconSideFilter(search);
    }
    const outputJson = deserialize(search);
    let searchIdx = search.index;
    const currSearchIdx = parseInt(search.index);
    if (currSearchIdx < 0 || isNaN(currSearchIdx)) {
        searchIdx = search.store.emptyPlace.toString();
    }
    return saveSearch(searchIdx, outputJson, search.ignoreCase, search.name)
        .then(res => {
            if (search.isPrevious) {
                search.store.addSearch(search);
            } else if (search.isNew) {
                search.store.setNewSearch(search);
                search.store.saveNewSearch();
            } else {
                search.store.setSearch(search);
            }
        })
        .catch(err => console.log(err));
}

export function getSearchSavedMessage(search) {
    const msg =
        search.index < 10
            ? getLocalizedText(texts.savedWithHotKey)
            : getLocalizedText(texts.savedWithoutHotKey);
    return msg
        .replace(placeholders.searchTitle, search.name)
        .replace(placeholders.searchPlace, search.index)
        .replace(placeholders.searchHotKey, 'Ctrl+' + search.index);
}
